import React from 'react';

import { Stack, Switch, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';

import type { Control } from 'react-hook-form';

import TimeFieldComp from '@/components/TimeFieldComp';

/**
 * 睡眠入力タイプ
 */
export type SleepInputType = {
  /** 昨日で登録 */
  isYesterday: boolean,
  /** 測定日時 */
  measureDateTime: string,
}

/**
 * 入力フォーム
 */
export type SleepFormInputType = {
  /** コントローラー */
  control: Control<SleepInputType, never>,
  /** エラー */
  errors: any,
}

const SleepFormInput: React.FC<SleepFormInputType> = ({
  control,
  errors,
}) => (
  <div>
    <div style={{ margin: '10px 0' }}>
      <Controller
        render={
          ({ field }) => (
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
              <Switch
                defaultChecked={field.value}
                onChange={field.onChange}
              />
              <Typography>昨日の就寝で登録</Typography>
            </Stack>
          )
        }
        name="isYesterday"
        control={control as any}
      />
    </div>
    <TimeFieldComp
      control={control}
      name="measureDateTime"
      label="日時"
      rules={{
        required: '必須項目です',
      }}
      errors={errors}
    />
  </div>
);

export default SleepFormInput;
